import * as React from "react"
import {
  ContainerIcon,
  MuteButton,
  MuteIcon,
  VolumeIcon
} from "../custom-player.styled"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { Tooltip } from "../../../common/tooltip"
import { MdPeople } from "react-icons/md"

export interface MuteButtonPlayerProps {
  isMuted: boolean
  label?: string
  style?: React.CSSProperties
  handleMute: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  handleTouchStart: (event: React.TouchEvent<HTMLButtonElement>) => void
  handleOnTouchEndMute: (event: React.TouchEvent<HTMLButtonElement>) => void
}

const _MuteButtonPlayer: React.FC<MuteButtonPlayerProps> = ({
  handleMute,
  isMuted,
  handleTouchStart,
  handleOnTouchEndMute,
  label = "Global audio",
  style
}) => {
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <Tooltip
      label={label}
      placement="bottom"
    >
      <MuteButton
        onClick={handleMute}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleOnTouchEndMute}
        roomStyles={roomStyles}
        style={style}
      >
         <ContainerIcon roomStyles={roomStyles} style={{ padding: "2px" }}>
          <MdPeople size="22" />
          {isMuted ? <MuteIcon /> : <VolumeIcon />}
        </ContainerIcon>
      </MuteButton>
    </Tooltip>
  )
}

export const MuteButtonPlayer = React.memo(_MuteButtonPlayer)
